(function () {
  const addZero = (x) => (x < 10 && x >= 0 ? "0" + x : x);

  const getHostSuffix = () => {
    const host = window.location.host;
    if (host.includes(".au")) return "au";
    if (host.includes(".nz")) return "nz";
    return "default";
  };

  const updateCountdown = (target, hourElem, minElem, secElem, endCallback) => {
    const now = new Date();
    const timeAttr = target.getAttribute("data-time");
    if (!timeAttr) return;

    const [targetHour, targetMin] = timeAttr.split(":").map(Number);

    const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), targetHour, targetMin, 0, 0).getTime();

    const tick = () => {
      const nowTime = new Date().getTime();
      const distance = endTime - nowTime;

      if (distance <= 0) {
        endCallback();
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      hourElem.querySelector(".num").textContent = addZero(hours);
      hourElem.querySelector(".word").textContent = "hours";
      minElem.querySelector(".num").textContent = addZero(minutes);
      minElem.querySelector(".word").textContent = "minutes";
      secElem.querySelector(".num").textContent = addZero(seconds);
      secElem.querySelector(".word").textContent = "seconds";

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const wrapper = document.querySelector(".countdown-wrapper-daily");
  const countdown = wrapper?.querySelector(".countdown-daily");

  if (wrapper && countdown) {
    const hourElem = countdown.querySelector(".hour");
    const minElem = countdown.querySelector(".min");
    const secElem = countdown.querySelector(".sec");

    updateCountdown(countdown, hourElem, minElem, secElem, () => {
      const hostType = getHostSuffix();
      if (hostType === "au") {
        wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay | Zip</span>";
      } else if (hostType === "nz") {
        wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay</span>";
      } else {
        wrapper.innerHTML = "<span>Buy Now Pay Later - Afterpay</span>";
      }
    });
  }
})();
